import {action, makeObservable, observable} from 'mobx';
import Get from 'app/utils/Get';
import OtherItemInterface from 'app/interfaces/shop/OtherItemInterface';

export class OtherItemStore {
    constructor() {
        makeObservable(this);
    }

    @observable item: OtherItemInterface | null = null;

    @action
    updateItem(item: OtherItemInterface | null): void {
        this.item = item;
    }

    getItem(id: string): void {
        new Get({url: `/shop/other/${id}`})
            .execute()
            .then(response => {
                if (!response.ok) {
                    throw response;
                }

                return response.json();
            })
            .then(r => this.updateItem(r));
    }
}
